(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weare-animated-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const controllers = new Map();
    const rootSelector = '[data-weare-animated-hero]';

    const createController = (root) => {
      const motionTargets = Array.from(root.querySelectorAll('[data-weare-motion]'));
      const scrollTargets = motionTargets.filter((target) => target.dataset.weareMotion === 'scroll-up' || target.dataset.weareMotion === 'scroll-down');
      const pointerTargets = motionTargets.filter((target) => target.dataset.weareMotion === 'cursor-follow' || target.dataset.weareMotion === 'cursor-repel');
      const mediaVideos = Array.from(root.querySelectorAll('video'));
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const finePointer = window.matchMedia('(pointer: fine)').matches;
      let animationFrame = null;
      let pointerX = 0;
      let pointerY = 0;

      const strengthFor = (target) => Math.min(40, Math.max(0, Number(target.dataset.motionStrength) || 0));

      const update = () => {
        animationFrame = null;

        if (reducedMotionQuery.matches) return;

        if (scrollTargets.length) {
          const rect = root.getBoundingClientRect();
          const progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / (window.innerHeight + rect.height)));
          const centeredProgress = (progress - 0.5) * 2;

          scrollTargets.forEach((target) => {
            const direction = target.dataset.weareMotion === 'scroll-up' ? -1 : 1;
            target.style.setProperty('--weare-motion-x', '0px');
            target.style.setProperty('--weare-motion-y', `${centeredProgress * strengthFor(target) * direction}px`);
          });
        }

        pointerTargets.forEach((target) => {
          const direction = target.dataset.weareMotion === 'cursor-repel' ? -1 : 1;
          const strength = strengthFor(target);
          target.style.setProperty('--weare-motion-x', `${pointerX * strength * direction}px`);
          target.style.setProperty('--weare-motion-y', `${pointerY * strength * direction}px`);
        });
      };

      const scheduleUpdate = () => {
        if (animationFrame === null) animationFrame = window.requestAnimationFrame(update);
      };

      const handlePointerMove = (event) => {
        const rect = root.getBoundingClientRect();
        pointerX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        pointerY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        scheduleUpdate();
      };

      const handlePointerLeave = () => {
        pointerX = 0;
        pointerY = 0;
        scheduleUpdate();
      };

      const syncVideoPlayback = () => {
        mediaVideos.forEach((video) => {
          if (reducedMotionQuery.matches) {
            video.pause();
            video.currentTime = 0;
            return;
          }

          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        });
      };

      const handleReducedMotionChange = () => {
        if (reducedMotionQuery.matches) {
          motionTargets.forEach((target) => {
            target.style.removeProperty('--weare-motion-x');
            target.style.removeProperty('--weare-motion-y');
          });
        }

        syncVideoPlayback();
        scheduleUpdate();
      };

      if (scrollTargets.length) {
        window.addEventListener('scroll', scheduleUpdate, { passive: true });
        window.addEventListener('resize', scheduleUpdate);
      }

      if (finePointer && pointerTargets.length) {
        root.addEventListener('pointermove', handlePointerMove, { passive: true });
        root.addEventListener('pointerleave', handlePointerLeave);
      }

      reducedMotionQuery.addEventListener('change', handleReducedMotionChange);
      syncVideoPlayback();
      scheduleUpdate();

      return {
        destroy() {
          window.removeEventListener('scroll', scheduleUpdate);
          window.removeEventListener('resize', scheduleUpdate);
          root.removeEventListener('pointermove', handlePointerMove);
          root.removeEventListener('pointerleave', handlePointerLeave);
          reducedMotionQuery.removeEventListener('change', handleReducedMotionChange);

          if (animationFrame !== null) window.cancelAnimationFrame(animationFrame);
        },
      };
    };

    const initialize = (root) => {
      if (!root || controllers.has(root)) return;
      controllers.set(root, createController(root));
    };

    const findRoot = (eventTarget) => {
      if (!(eventTarget instanceof Element)) return null;
      if (eventTarget.matches(rootSelector)) return eventTarget;
      return eventTarget.querySelector(rootSelector);
    };

    const initializeExisting = () => {
      document.querySelectorAll(rootSelector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeExisting, { once: true });
    } else {
      initializeExisting();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(findRoot(event.target));
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = findRoot(event.target);
      const controller = root && controllers.get(root);

      if (!controller) return;
      controller.destroy();
      controllers.delete(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weare-media-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-weare-media-slideshow]';
    const controllers = new Map();

    const createController = (root) => {
      const slides = Array.from(root.querySelectorAll('.weare-media-slideshow__slide'));
      const dots = Array.from(root.querySelectorAll('[data-slide-dot]'));
      const previousButton = root.querySelector('[data-slide-previous]');
      const nextButton = root.querySelector('[data-slide-next]');
      const playPauseButton = root.querySelector('[data-slide-play-pause]');
      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileVideoQuery = window.matchMedia('(max-width: 749px)');
      const loopSlideshow = root.dataset.loopSlideshow !== 'false';

      let currentIndex = Math.max(
        0,
        slides.findIndex((slide) => slide.classList.contains('is-active'))
      );
      let timer = null;
      let paused = reducedMotionQuery.matches;
      let hiddenPause = false;
      let destroyed = false;
      const blockedPlayers = new WeakSet();
      const manualPlayback = new WeakSet();
      const commandedPauses = new WeakSet();
      const readyVimeoPlayers = new WeakSet();
      const completedVimeoPlayers = new WeakSet();
      const videoDimensions = new WeakMap();

      const activeSlide = () => slides[currentIndex] || null;

      const activeVideoPlayer = (slide) => {
        if (!slide) return null;

        const preferredVariant =
          mobileVideoQuery.matches && slide.classList.contains('has-mobile-video')
            ? 'mobile'
            : 'desktop';

        const variant =
          slide.querySelector(`[data-video-variant="${preferredVariant}"]`) ||
          slide.querySelector('[data-video-variant="desktop"]');

        return variant?.querySelector('video, iframe') || null;
      };

      const sectionIsVisible = () => {
        const visibility = root.dataset.sectionVisibility || 'both';
        return visibility === 'both' ||
          (visibility === 'desktop' && !mobileVideoQuery.matches) ||
          (visibility === 'mobile' && mobileVideoQuery.matches);
      };

      const autoplayAllowed = (slide) => Boolean(slide && (
        slide.dataset.mediaKind === 'image' ||
        slide.dataset.autoplay !== 'false' || manualPlayback.has(slide)
      ));

      const canPlay = (slide) =>
        !destroyed && !paused && !document.hidden && sectionIsVisible() &&
        slide === activeSlide() && autoplayAllowed(slide);

      const sizeExternalPlayers = () => {
        slides.forEach((slide) => {
          slide.querySelectorAll('[data-external-player]').forEach((iframe) => {
            const variant = iframe.closest('[data-video-variant]');
            const width = variant?.clientWidth || 0;
            const height = variant?.clientHeight || 0;
            if (!width || !height) return;

            if (slide.dataset.videoControls === 'true') {
              iframe.style.setProperty('--weare-frame-width', `${width}px`);
              iframe.style.setProperty('--weare-frame-height', `${height}px`);
              return;
            }

            const dimensions = videoDimensions.get(iframe);
            const ratio = dimensions?.width > 0 && dimensions?.height > 0
              ? dimensions.width / dimensions.height
              : 16 / 9;
            const frameWidth = Math.max(width, height * ratio);
            const frameHeight = frameWidth / ratio;

            iframe.style.setProperty('--weare-frame-width', `${frameWidth}px`);
            iframe.style.setProperty('--weare-frame-height', `${frameHeight}px`);
          });
        });
      };

      const clearTimer = () => {
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
      };

      const postToPlayer = (iframe, message) => {
        if (!iframe?.contentWindow) return;
        const origin = iframe.dataset.externalPlayer === 'vimeo'
          ? 'https://player.vimeo.com'
          : '*';
        iframe.contentWindow.postMessage(JSON.stringify(message), origin);
      };

      const pauseSlide = (slide, reset = false) => {
        clearTimer();

        if (!slide) return;

        slide.querySelectorAll('video').forEach((video) => {
          video.autoplay = false;
          video.pause();

          if (reset) {
            try {
              video.currentTime = 0;
            } catch {}
          }
        });

        slide.querySelectorAll('[data-external-player]').forEach((iframe) => {
          commandedPauses.add(iframe);
          if (iframe.dataset.externalPlayer === 'youtube') {
            postToPlayer(iframe, {
              event: 'command',
              func: 'pauseVideo',
              args: []
            });

            if (reset) {
              postToPlayer(iframe, {
                event: 'command',
                func: 'seekTo',
                args: [0, true]
              });
            }
          } else {
            postToPlayer(iframe, {
              method: 'pause'
            });

            if (reset) {
              postToPlayer(iframe, {
                method: 'setCurrentTime',
                value: 0
              });
            }
          }
        });
      };

      const updatePlayPauseButton = () => {
        if (!playPauseButton) return;

        const showPlay = paused || !autoplayAllowed(activeSlide()) ||
          blockedPlayers.has(activeVideoPlayer(activeSlide()));

        playPauseButton.setAttribute(
          'aria-label',
          showPlay
            ? playPauseButton.dataset.playLabel
            : playPauseButton.dataset.pauseLabel
        );

        playPauseButton.querySelector('[data-play-icon]').hidden = !showPlay;
        playPauseButton.querySelector('[data-pause-icon]').hidden = showPlay;
      };

      const stopAtEnd = () => {
        clearTimer();
        paused = true;
        updatePlayPauseButton();
      };

      const goToRelative = (direction, focusSlide = false, automatic = false) => {
        if (!slides.length) return;

        const requestedIndex = currentIndex + direction;

        if (loopSlideshow) {
          const nextIndex =
            (requestedIndex + slides.length) % slides.length;

          showSlide(nextIndex, focusSlide);
          return;
        }

        if (requestedIndex < 0 || requestedIndex >= slides.length) {
          if (automatic && requestedIndex >= slides.length) {
            stopAtEnd();
          }

          return;
        }

        showSlide(requestedIndex, focusSlide);
      };

      const playSlide = (slide) => {
        clearTimer();

        if (!slide || destroyed || document.hidden || !sectionIsVisible() ||
            slide !== activeSlide()) return;

        if (slide.dataset.mediaKind === 'image') {
          if (!canPlay(slide)) return;
          const imageDuration =
            Math.max(1, Number(slide.dataset.imageDuration) || 5) * 1000;

          timer = window.setTimeout(() => {
            goToRelative(1, false, true);
          }, imageDuration);

          return;
        }

        const player = activeVideoPlayer(slide);

        if (!player) return;

        const shouldPlay = canPlay(slide);
        const muted = slide.dataset.muted !== 'false';
        const showControls = slide.dataset.videoControls === 'true';

        if (player.tagName === 'VIDEO') {
          player.defaultMuted = muted;
          player.muted = muted;
          player.controls = showControls;
          player.playsInline = true;
          player.toggleAttribute('muted', muted);
          player.setAttribute('playsinline', '');
          player.setAttribute('webkit-playsinline', '');
          player.preload = 'auto';
          player.autoplay = shouldPlay && slide.dataset.autoplay !== 'false';
          if (!shouldPlay) return;

          const playPromise = player.play();

          if (playPromise) {
            playPromise.then(() => {
              blockedPlayers.delete(player);
              updatePlayPauseButton();

              if (!canPlay(slide) || player !== activeVideoPlayer(slide)) {
                player.autoplay = false;
                player.pause();
              }
            }).catch((error) => {
              if (!canPlay(slide) || player !== activeVideoPlayer(slide)) return;

              if (error.name === 'NotAllowedError') {
                blockedPlayers.add(player);
                updatePlayPauseButton();
              }
            });
          }

          return;
        }

        if (!shouldPlay && autoplayAllowed(slide)) return;
        sizeExternalPlayers();

        if (!player.hasAttribute('src') && player.dataset.src) {
          player.loading = 'eager';
          const url = new URL(player.dataset.src);
          url.searchParams.set('autoplay', shouldPlay ? '1' : '0');
          url.searchParams.set(player.dataset.externalPlayer === 'vimeo' ? 'muted' : 'mute', muted ? '1' : '0');
          url.searchParams.set('controls', showControls ? '1' : '0');
          if (player.dataset.externalPlayer === 'vimeo') {
            url.searchParams.set('background', shouldPlay && muted && !showControls ? '1' : '0');
          }
          player.src = url.toString();
          return;
        }

        if (!shouldPlay) return;

        if (player.dataset.externalPlayer === 'youtube') {
          postToPlayer(player, {
            event: 'listening',
            id: player.id || ''
          });

          postToPlayer(player, {
            event: 'command',
            func: muted ? 'mute' : 'unMute',
            args: []
          });

          postToPlayer(player, {
            event: 'command',
            func: 'playVideo',
            args: []
          });
        } else {
          if (!readyVimeoPlayers.has(player)) {
            postToPlayer(player, { method: 'ping' });
            return;
          }

          if (completedVimeoPlayers.has(player)) {
            postToPlayer(player, { method: 'setCurrentTime', value: 0 });
          } else {
            player.style.visibility = '';
          }

          postToPlayer(player, { method: 'setLoop', value: false });
          postToPlayer(player, { method: 'setMuted', value: muted });
          postToPlayer(player, { method: 'setVolume', value: muted ? 0 : 1 });
          postToPlayer(player, { method: 'play' });
        }
      };

      function showSlide(index, focusSlide = false) {
        if (!slides.length) return;

        let normalizedIndex = index;

        if (loopSlideshow) {
          normalizedIndex =
            (index + slides.length) % slides.length;
        } else {
          normalizedIndex =
            Math.max(0, Math.min(index, slides.length - 1));
        }

        const outgoing = activeSlide();

        if (outgoing && (normalizedIndex !== currentIndex ||
            completedVimeoPlayers.has(activeVideoPlayer(outgoing)))) {
          pauseSlide(outgoing, true);
        }

        if (outgoing && normalizedIndex !== currentIndex) {
          manualPlayback.delete(outgoing);
        }
        currentIndex = normalizedIndex;
        root.classList.toggle('has-active-video-controls',
          activeSlide()?.dataset.mediaKind === 'video' &&
          activeSlide()?.dataset.videoControls === 'true');

        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === currentIndex;

          slide.classList.toggle('is-active', active);
          slide.setAttribute(
            'aria-hidden',
            active ? 'false' : 'true'
          );
        });

        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === currentIndex;

          dot.classList.toggle('is-active', active);
          dot.setAttribute(
            'aria-current',
            active ? 'true' : 'false'
          );
        });

        if (focusSlide) {
          activeSlide()?.focus({
            preventScroll: true
          });
        }

        updatePlayPauseButton();
        playSlide(activeSlide());
      }

      const handleHostedReady = (event) => {
        const video = event.currentTarget;
        const slide = video.closest('.weare-media-slideshow__slide');

        if (canPlay(slide) && video === activeVideoPlayer(slide) && video.paused && !video.ended) {
          playSlide(slide);
        }
      };

      const handleHostedPlay = (event) => {
        const video = event.currentTarget;
        const slide = video.closest('.weare-media-slideshow__slide');
        if (destroyed || document.hidden || !sectionIsVisible() ||
            slide !== activeSlide() || video !== activeVideoPlayer(slide) ||
            (!canPlay(slide) && slide.dataset.videoControls !== 'true')) {
          video.pause();
          return;
        }
        manualPlayback.add(slide);
        paused = false;
        blockedPlayers.delete(video);
        updatePlayPauseButton();
      };

      const handleHostedPause = (event) => {
        const video = event.currentTarget;
        const slide = video.closest('.weare-media-slideshow__slide');
        if (canPlay(slide) && video === activeVideoPlayer(slide) &&
            video.paused && !video.ended) {
          paused = true;
          updatePlayPauseButton();
        }
      };

      const handlePlaybackGesture = () => {
        const slide = activeSlide();
        const player = activeVideoPlayer(slide);

        if (canPlay(slide) && player && blockedPlayers.has(player)) {
          blockedPlayers.delete(player);
          playSlide(slide);
        }
      };

      const handlePageShow = () => {
        playSlide(activeSlide());
      };

      const pauseExternalPlayer = (iframe) => {
        commandedPauses.add(iframe);
        postToPlayer(iframe, iframe.dataset.externalPlayer === 'youtube'
          ? { event: 'command', func: 'pauseVideo', args: [] }
          : { method: 'pause' });
      };

      const handleHostedEnded = (event) => {
        const video = event.currentTarget;
        const slide =
          video.closest('.weare-media-slideshow__slide');

        if (!canPlay(slide)) return;
        if (video !== activeVideoPlayer(slide)) return;

        goToRelative(1, false, true);
      };

      const initializeVimeoPlayer = (iframe) => {
        if (readyVimeoPlayers.has(iframe) || destroyed) return;
        readyVimeoPlayers.add(iframe);

        ['ended', 'timeupdate', 'play', 'pause', 'loaded'].forEach((eventName) => {
          postToPlayer(iframe, { method: 'addEventListener', value: eventName });
        });
        postToPlayer(iframe, { method: 'getVideoWidth' });
        postToPlayer(iframe, { method: 'getVideoHeight' });
        postToPlayer(iframe, { method: 'setLoop', value: false });

        const slide = iframe.closest('.weare-media-slideshow__slide');
        if (canPlay(slide) && iframe === activeVideoPlayer(slide)) {
          playSlide(slide);
        } else {
          pauseExternalPlayer(iframe);
        }
      };

      const finishVimeoPlayer = (iframe) => {
        const slide = iframe.closest('.weare-media-slideshow__slide');
        if (!canPlay(slide) || iframe !== activeVideoPlayer(slide) ||
            completedVimeoPlayers.has(iframe)) return;

        completedVimeoPlayers.add(iframe);
        iframe.style.visibility = 'hidden';
        pauseExternalPlayer(iframe);
        goToRelative(1, false, true);
      };

      const handleMessage = (event) => {
        const allowedOrigin =
          event.origin.includes('youtube.com') ||
          event.origin.includes('youtube-nocookie.com') ||
          event.origin.includes('vimeo.com');

        if (!allowedOrigin) return;

        const iframe = slides
          .flatMap((slide) =>
            Array.from(
              slide.querySelectorAll('[data-external-player]')
            )
          )
          .find(
            (player) =>
              player.contentWindow === event.source
          );

        if (!iframe) return;

        const slide =
          iframe.closest('.weare-media-slideshow__slide');

        let data = event.data;

        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch {
            return;
          }
        }

        if (!data || typeof data !== 'object') return;

        if (iframe.dataset.externalPlayer === 'vimeo') {
          if (data.event === 'ready' || data.method === 'ping') {
            initializeVimeoPlayer(iframe);
            return;
          }

          if (data.method === 'getVideoWidth' || data.method === 'getVideoHeight') {
            const dimensions = videoDimensions.get(iframe) || {};
            const key = data.method === 'getVideoWidth' ? 'width' : 'height';
            const value = Number(data.value);
            if (Number.isFinite(value) && value > 0) {
              dimensions[key] = value;
              videoDimensions.set(iframe, dimensions);
              sizeExternalPlayers();
            }
            return;
          }

          if (data.event === 'loaded') {
            postToPlayer(iframe, { method: 'getVideoWidth' });
            postToPlayer(iframe, { method: 'getVideoHeight' });
            return;
          }
        } else if (data.event === 'onReady') {
          handleIframeLoad({ currentTarget: iframe });
          return;
        }

        const playerState = data.event === 'onStateChange' ? data.info : data.info?.playerState;
        const played = iframe.dataset.externalPlayer === 'vimeo'
          ? data.event === 'play' : playerState === 1;
        const stopped = iframe.dataset.externalPlayer === 'vimeo'
          ? data.event === 'pause' : playerState === 2;

        if (stopped && commandedPauses.has(iframe)) {
          commandedPauses.delete(iframe);
          return;
        }

        if (played) {
          if (destroyed || document.hidden || !sectionIsVisible() ||
              slide !== activeSlide() || iframe !== activeVideoPlayer(slide) ||
              (!canPlay(slide) && slide.dataset.videoControls !== 'true')) {
            pauseExternalPlayer(iframe);
            return;
          }
          commandedPauses.delete(iframe);
          manualPlayback.add(slide);
          paused = false;
          blockedPlayers.delete(iframe);
          updatePlayPauseButton();
        }

        if (!canPlay(slide) || iframe !== activeVideoPlayer(slide)) return;
        if (stopped && slide.dataset.videoControls === 'true') {
          paused = true;
          updatePlayPauseButton();
          return;
        }

        if (data.event === 'onAutoplayBlocked' ||
            (data.event === 'error' && data.data?.method === 'play')) {
          blockedPlayers.add(iframe);
          updatePlayPauseButton();
          return;
        }

        if (iframe.dataset.externalPlayer === 'youtube') {
          if (playerState === 0) {
            goToRelative(1, false, true);
          }
        } else {
          const seconds = Number(data.data?.seconds);
          const duration = Number(data.data?.duration);
          const validProgress = Number.isFinite(seconds) &&
            Number.isFinite(duration) && duration > 0;

          if ((data.event === 'timeupdate' || data.event === 'play') &&
              validProgress && seconds < duration - 0.12) {
            completedVimeoPlayers.delete(iframe);
            iframe.style.visibility = '';
          }

          if (data.event === 'ended' ||
              (data.event === 'timeupdate' && validProgress &&
                duration - seconds <= 0.12)) {
            finishVimeoPlayer(iframe);
          }
        }
      };

      const handleIframeLoad = (event) => {
        const iframe = event.currentTarget;

        if (iframe.dataset.externalPlayer === 'youtube') {
          postToPlayer(iframe, {
            event: 'listening',
            id: iframe.id || ''
          });

          ['onStateChange', 'onAutoplayBlocked'].forEach((eventName) => {
            postToPlayer(iframe, {
              event: 'command',
              func: 'addEventListener',
              args: [eventName]
            });
          });
        } else {
          postToPlayer(iframe, { method: 'ping' });
          return;
        }

        const slide =
          iframe.closest('.weare-media-slideshow__slide');

        if (
          canPlay(slide) &&
          iframe === activeVideoPlayer(slide)
        ) {
          playSlide(slide);
        } else {
          pauseExternalPlayer(iframe);
        }
      };

      const handlePrevious = () => {
        goToRelative(-1, true, false);
      };

      const handleNext = () => {
        goToRelative(1, true, false);
      };

      const handlePlayPause = () => {
        const slide = activeSlide();
        const player = activeVideoPlayer(slide);
        const start = paused || !autoplayAllowed(slide) || blockedPlayers.has(player);
        paused = !start;
        if (start && slide) {
          manualPlayback.add(slide);
          if (player) blockedPlayers.delete(player);
        }

        if (paused) {
          pauseSlide(activeSlide());
        } else {
          playSlide(activeSlide());
        }

        updatePlayPauseButton();
      };

      const handleVisibilityChange = () => {
        if (document.hidden) {
          hiddenPause = !paused;

          if (hiddenPause) {
            pauseSlide(activeSlide());
          }
        } else if (hiddenPause) {
          hiddenPause = false;
          playSlide(activeSlide());
        }
      };

      const handleReducedMotionChange = () => {
        if (!reducedMotionQuery.matches) return;

        paused = true;
        pauseSlide(activeSlide());
        updatePlayPauseButton();
      };

      const handleBreakpointChange = () => {
        pauseSlide(activeSlide(), true);
        playSlide(activeSlide());
      };

      slides.forEach((slide) => {
        slide
          .querySelectorAll('video')
          .forEach((video) => {
            video.autoplay = false;
            video.addEventListener('ended', handleHostedEnded);
            video.addEventListener('play', handleHostedPlay);
            video.addEventListener('pause', handleHostedPause);
            video.addEventListener('loadeddata', handleHostedReady);
            video.addEventListener('canplay', handleHostedReady);
          });

        slide
          .querySelectorAll('[data-external-player]')
          .forEach((iframe) =>
            iframe.addEventListener(
              'load',
              handleIframeLoad
            )
          );
      });

      dots.forEach((dot) =>
        dot.addEventListener('click', () => {
          showSlide(
            Number(dot.dataset.slideDot),
            true
          );
        })
      );

      previousButton?.addEventListener(
        'click',
        handlePrevious
      );

      nextButton?.addEventListener(
        'click',
        handleNext
      );

      playPauseButton?.addEventListener(
        'click',
        handlePlayPause
      );

      reducedMotionQuery.addEventListener(
        'change',
        handleReducedMotionChange
      );

      mobileVideoQuery.addEventListener(
        'change',
        handleBreakpointChange
      );

      document.addEventListener(
        'visibilitychange',
        handleVisibilityChange
      );

      window.addEventListener(
        'message',
        handleMessage
      );

      ['pointerup', 'touchend', 'keydown'].forEach((eventName) => {
        document.addEventListener(eventName, handlePlaybackGesture, { passive: true });
      });
      window.addEventListener('pageshow', handlePageShow);

      const visibilityObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          const slide = activeSlide();
          const player = activeVideoPlayer(slide);

          if (!canPlay(slide) || !player || !blockedPlayers.has(player)) return;

          blockedPlayers.delete(player);
          playSlide(slide);
        }, { threshold: 0.05 })
        : null;

      visibilityObserver?.observe(root);

      const resizeObserver = 'ResizeObserver' in window
        ? new ResizeObserver(sizeExternalPlayers)
        : null;
      resizeObserver?.observe(root);
      window.addEventListener('resize', sizeExternalPlayers);
      sizeExternalPlayers();

      updatePlayPauseButton();
      showSlide(currentIndex);

      return {
        selectBlock(blockId) {
          const index = slides.findIndex(
            (slide) =>
              slide.dataset.blockId === blockId
          );

          if (index < 0) return;

          paused = true;
          updatePlayPauseButton();
          showSlide(index);
        },

        destroy() {
          destroyed = true;
          visibilityObserver?.disconnect();
          resizeObserver?.disconnect();
          window.removeEventListener('resize', sizeExternalPlayers);
          clearTimer();
          pauseSlide(activeSlide());

          slides.forEach((slide) => {
            slide
              .querySelectorAll('video')
              .forEach((video) => {
                video.removeEventListener('ended', handleHostedEnded);
                video.removeEventListener('play', handleHostedPlay);
                video.removeEventListener('pause', handleHostedPause);
                video.removeEventListener('loadeddata', handleHostedReady);
                video.removeEventListener('canplay', handleHostedReady);
              });

            slide
              .querySelectorAll('[data-external-player]')
              .forEach((iframe) =>
                iframe.removeEventListener(
                  'load',
                  handleIframeLoad
                )
              );
          });

          ['pointerup', 'touchend', 'keydown'].forEach((eventName) => {
            document.removeEventListener(eventName, handlePlaybackGesture);
          });
          window.removeEventListener('pageshow', handlePageShow);

          previousButton?.removeEventListener(
            'click',
            handlePrevious
          );

          nextButton?.removeEventListener(
            'click',
            handleNext
          );

          playPauseButton?.removeEventListener(
            'click',
            handlePlayPause
          );

          reducedMotionQuery.removeEventListener(
            'change',
            handleReducedMotionChange
          );

          mobileVideoQuery.removeEventListener(
            'change',
            handleBreakpointChange
          );

          document.removeEventListener(
            'visibilitychange',
            handleVisibilityChange
          );

          window.removeEventListener(
            'message',
            handleMessage
          );
        }
      };
    };

    const initialize = (root) => {
      if (!root || controllers.has(root)) return;

      controllers.set(
        root,
        createController(root)
      );
    };

    const findRoot = (target) => {
      if (!(target instanceof Element)) return null;

      return target.matches(selector)
        ? target
        : target.querySelector(selector);
    };

    const initializeExisting = () => {
      document
        .querySelectorAll(selector)
        .forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeExisting,
        { once: true }
      );
    } else {
      initializeExisting();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initialize(findRoot(event.target));
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        const root = findRoot(event.target);
        const controller =
          root && controllers.get(root);

        if (!controller) return;

        controller.destroy();
        controllers.delete(root);
      }
    );

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const root =
          event.target.closest(selector);

        controllers
          .get(root)
          ?.selectBlock(event.detail.blockId);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
